/**
 * Feed-row meta: one tone dot per event kind, with an explicit fallback so
 * an event type this build doesn't know yet renders neutrally instead of
 * crashing (the FO timeline-meta rule).
 * For Media Devoted | Created By Ciro Autiero
 */
const TONES: Record<string, string> = {
  day_generated: 'hsl(var(--primary))',
  drop_sent: 'hsl(var(--success))',
  drop_pinned: 'hsl(var(--primary))',
  slot_skipped: 'hsl(var(--warning))',
  slot_reset: 'hsl(var(--primary))',
  creative_done: 'hsl(var(--primary))',
  creative_failed: 'hsl(var(--warning))',
  verdict_evaluated: 'hsl(var(--primary))',
  list_burned: 'hsl(var(--destructive))',
  group_stopped: 'hsl(var(--warning))',
  pool_reset: 'hsl(var(--success))',
  // 21/10/2026 — a group forgot the list it was on (a rule / order / formula change, or Re-pick)
  list_repicked: 'hsl(var(--primary))',
  scale_up: 'hsl(var(--success))',
  scale_capped: 'hsl(var(--warning))',
  // Phase 31 — a weak check took a step down; a rested list came back
  scale_down: 'hsl(var(--warning))',
  list_returned: 'hsl(var(--primary))',
  // Phase 38 — a sent drop hit the Hit again rule: a new drop goes out right now
  hit_again: 'hsl(var(--success))',
  // Phase 32 — an alert could not be delivered
  notification_failed: 'hsl(var(--warning))',
  simulation_cleared: 'hsl(var(--muted-foreground))',
  // Phase 9 — auto-send
  autosend_on: 'hsl(var(--primary))',
  autosend_off: 'hsl(var(--muted-foreground))',
  autosend_limits: 'hsl(var(--primary))',
  autosend_resumed: 'hsl(var(--success))',
  autosend_halted: 'hsl(var(--destructive))',
  autosend_held: 'hsl(var(--warning))',
  autosend_missed: 'hsl(var(--warning))',
  send_failed: 'hsl(var(--destructive))',
  kill_on: 'hsl(var(--destructive))',
  kill_off: 'hsl(var(--success))',
  // Phase 17 — a gateway verdict blocked a route for the day
  gateway_blocked: 'hsl(var(--destructive))',
  // Phase 36 — gateway experiments
  experiment_started: 'hsl(var(--primary))',
  experiment_done: 'hsl(var(--primary))',
  experiment_applied: 'hsl(var(--success))',
  experiment_stopped: 'hsl(var(--muted-foreground))',
  // Phase 29 — shadow mode: decided like a send, sent nothing
  autosend_shadow: 'hsl(var(--warning))',
  autosend_shadow_halt: 'hsl(var(--warning))',
  // Phase 21 — an old slot mode became one list of drops (same drops)
  slots_listed: 'hsl(var(--muted-foreground))',
  floors_to_rules: 'hsl(var(--muted-foreground))',
  // 19/10/2026 — an error without a feed word of its own
  automation_error: 'hsl(var(--destructive))',
  // 21/10/2026 — a traced error that is fixed now
  error_resolved: 'hsl(var(--success))',
};

export const eventToneColor = (event: string): string =>
  TONES[event] ?? 'hsl(var(--muted-foreground))';

/** Feed times are Danish wall-clock — the app's operational clock. */
export const feedTime = (atIso: string): string =>
  new Date(atIso).toLocaleTimeString('en-GB', {
    hour: '2-digit',
    minute: '2-digit',
    timeZone: 'Europe/Copenhagen',
  });
